import { render, staticRenderFns } from "./RevisionFilters.vue?vue&type=template&id=1cd1f870"
import script from "./RevisionFilters.vue?vue&type=script&lang=js"
export * from "./RevisionFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports